import React, { useMemo, useState } from "react";
import * as Scrivito from "scrivito";
import { ProductReportsDownloadButtonsBlock } from "components";
import { items } from "variables";
import {
  useFetchScrivitoDocumentsForProduct,
  useTranslate,
  useUpdatedItemsForProductDownload,
} from "hooks";
import { ModalCheckboxesBlock } from "components/_Modals/ProjectDownloadModal/ModalCheckboxesBlock";
import {
  useProductOutput,
  useProductSeriesId,
  useProductNodeId,
} from "stores/product";
import type {
  CheckboxItem,
  OrderCode as ReportOrderCode,
} from "interfaces/product/product.types";

export const ProductDownloads = Scrivito.connect(() => {
  const translate = useTranslate();
  const [itemsData, setItemsData] = useState<CheckboxItem[]>(items);
  const [expandedAccordionIds, setExpandedAccordionIds] = useState<string[]>(
    [],
  );
  const productOutput = useProductOutput();
  const seriesId = useProductSeriesId();
  const nodeId = useProductNodeId();

  // TODO (25.11.25): LCA report can only be downloaded from SingleDownloadModal (should have nodeId)
  const filteredItems = useMemo(
    () => itemsData.filter((i) => i.id !== "LCA_REPORT"),
    [itemsData],
  );

  const { documents } = useFetchScrivitoDocumentsForProduct({
    seriesId,
  });

  useUpdatedItemsForProductDownload({
    documents,
    presentation: productOutput?.product?.orderCode?.presentation ?? "",
    setItemsData,
  });

  return (
    <div className="d-flex flex-column px-4 py-3 h-100 flex-shrink-2 bg-white rounded-2 gap-5">
      <h5>{translate("PRODUCT_CONFIGURATOR_DOWNLOADS")}</h5>
      <ModalCheckboxesBlock
        itemsData={filteredItems}
        setItemsData={setItemsData}
        blockTitle=""
        showProducts={false}
        expandedAccordionIds={expandedAccordionIds}
        setExpandedAccordionIds={setExpandedAccordionIds}
      />

      {productOutput?.product?.orderCode && (
        <ProductReportsDownloadButtonsBlock
          itemsData={filteredItems}
          setItemsData={setItemsData}
          documents={documents}
          orderCode={
            productOutput.product.orderCode as unknown as ReportOrderCode
          }
          setExpandedAccordionIds={setExpandedAccordionIds}
          nodeId={nodeId ?? ""}
        />
      )}
    </div>
  );
});
